import { objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { getTvObject, cn } from '@costar-ui/cosmos';
import baseModal from './base-modal.esm.js';

var tvObject = getTvObject(_objectSpread2(_objectSpread2({}, baseModal), {}, {
  base: cn(baseModal.base, 'rounded-lg').split(' ')
}));
var nextModal = tvObject;

export { nextModal as default };
//# sourceMappingURL=next-modal.esm.js.map
